import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { t } from 'i18n';
import DailyReports from 'views/DailyReports';

const JobDailyReportPopup = ({job, onClose}) => {
  if (!job) return null;

  const params = new URLSearchParams({
    idtype: 'id',
    id: String(job.id),
    taskid: String(job.id),
  });

  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      open
      onClose={onClose}
      PaperProps={{sx: {height: '90vh', maxHeight: '90vh'}}}
    >
      <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1, py: 1.25}}>
        <Box component="span" sx={{flex: 1, minWidth: 0}}>
          {t('Job Daily Report')} - {job.id}: {job.name}
        </Box>
        <IconButton aria-label="关闭日报表弹窗" edge="end" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{display: 'flex', minHeight: 0, p: 1}}>
        <DailyReports
          embedded
          initialSearchParams={params}
          showToolbar
          showScopeFilters={false}
          showDownload={false}
          showTrackerColumns
          columnSettingsTableId="report-jobdaily-popup"
        />
      </DialogContent>
    </Dialog>
  );
};

JobDailyReportPopup.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

export default JobDailyReportPopup;
